import React from 'react'; 
import PropTypes from 'prop-types';

import RadioSection from '../../Sections/RadioSection';

export default class CustomerType extends React.Component {
    render() {
        const customerType = this.props.lookup;
        return (
            <div>
                <RadioSection name="customerType" title={customerType.title} items={customerType.items} disabled={this.props.disabled} />
            </div>
        );

    }
}

CustomerType.propTypes = {
    lookup: PropTypes.object,
    disabled: PropTypes.bool
};